import { getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"
import { error, log, onResponse } from "./ApiUtils"

export class TasksApi {

    static getMyActiveYoutube(onSuccess, onError) {
        const params = getRequestParams()
        // console.log("getMyActiveYoutube params = ", params)
        fetchWithTimeout(getRequestUrl() + "getMyActiveYoutube", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getMyActiveYoutube response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getMyActiveYoutube error = ", e)
            error(onError, { response: -1 })
        })
    }
    static getOrdersWaitToAction(id, onSuccess, onError) {
        var params = getRequestParams()
        params.google_user_id = id
        console.log("getOrdersWaitToAction params = ", params)
        fetchWithTimeout(getRequestUrl() + "getOrdersWaitToAction", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getOrdersWaitToAction response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getOrdersWaitToAction error = ", e)
            error(onError, { response: -1 })
        })
    }


}
